var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-robot-box text-message",staticStyle:{"width":"fit-content"}},[_c('img',{ref:"image",attrs:{"src":_vm.message.content,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }